import { Input, Tooltip } from "@chakra-ui/react";
import { ChangeEvent, useState } from "react";

interface ThresholdInputProps {
  autoFocus: boolean;
  title: string;
  onChange: (e: ChangeEvent<HTMLInputElement>, key: string) => void;
  value: string;
  dataKey: string;
  label: string;
}

export const ThresholdInput = ({
  autoFocus,
  title,
  onChange,
  value,
  dataKey,
  label,
}: ThresholdInputProps) => {
  const [localValue, setLocalValue] = useState(value);
  let timeout: NodeJS.Timeout;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setLocalValue(e.target.value);

    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      onChange(e, dataKey);
    }, 0); //! Debounce -> Ajustar tempo caso necessário
  };

  return (
    <Tooltip label={label}>
      <Input
        autoFocus={autoFocus}
        width="50px"
        size="xs"
        title={title}
        type="number"
        onChange={handleChange}
        value={localValue}
        bg="rgba(49, 154, 221, 0.2)"
        border="1px solid #006699"
        borderColor="#006699"
        color="black"
        _focus={{ borderWidth: "2px" }}
      />
    </Tooltip>
  );
};
